<div *ngIf="!showCart" class="filter-section">
  <div class="date-filters">
    <label>
      Start Date:
      <input type="date" [(ngModel)]="startDate" />
    </label>

    <label>
      End Date:
      <input type="date" [(ngModel)]="endDate" />
    </label>
  </div>

  <div class="filter-buttons">
    <button mat-raised-button color="primary" (click)="page = 1; fetchLoads()">Apply Filter</button>
  </div>
</div>

<mat-card class="order-list-card" *ngIf="!showCart && loads.length > 0">
  <h3 class="card-title">Filtered Loads</h3>
  <app-load-table *ngIf="!showCart && loads.length > 0"
                  [isDraggable]="true"
                  [isSelectable] ="true"
                  [loads]="loads"
                  (loadSelected)="viewLoadDetails($event)">
  </app-load-table>

  <div class="pagination-controls">
    <button mat-button (click)="prevPage()" [disabled]="page === 1">Previous</button>
    <span>Page {{ page }} of {{ totalPages }}</span>
    <button mat-button (click)="nextPage()" [disabled]="page === totalPages">Next</button>
  </div>
  <div class="delivery-actions" *ngIf="deliveryBoys.length > 0" style="display: flex; align-items: center; gap: 1rem;">
    <mat-form-field appearance="fill" class="delivery-select" style="flex: 1; min-width: 200px;">
      <mat-label>Select Delivery Boy</mat-label>
      <mat-select [(ngModel)]="selectedUserId">
        <mat-option *ngFor="let user of deliveryBoys" [value]="user.id">{{ user.name }}</mat-option>
      </mat-select>
    </mat-form-field>

    <button mat-raised-button color="accent"
            (click)="assignDelivery()"
            [disabled]="!selectedUserId">
      Assign Delivery
    </button>
  </div>
</mat-card>

<div *ngIf="showCart">
  <app-load-viewer [load]="selectedLoad" (reloadDetails) = "onReloadDetails()"  (closedLoadDetails)="showCart = false"></app-load-viewer>
</div>
